import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const TaskSelectorHeader = () => {
  return (
    <Box gap="s8">
      <Text.Header2>
        {i18n.t('processes.process_settings.wizard.tasks.select_task.title')}
      </Text.Header2>
      <Text.Normal>
        {i18n.t('processes.process_settings.wizard.tasks.select_task.description')}
      </Text.Normal>
    </Box>
  )
}

export default TaskSelectorHeader
